import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PrintBulkVehicleService } from '../print-bulk-vehicle.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-bulk-vehicle-details',
  templateUrl: './bulk-vehicle-details.component.html',
  styleUrls: ['./bulk-vehicle-details.component.scss']
})
export class BulkVehicleDetailsComponent implements OnInit{
  displayedColumns: string[] = ['fusioncode', 'buildingName', 'entity', 'vehicleNumber', 'startingnumber', 'endingnumber', 'status'];
  dataAvailable = true;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  campusdetails: any;
  CampusId: any;
  buildingDetails: any;
  BuildingId: any;
  tableDetails: any;
  bulkQRData: any;
  constructor(private bulkservice: PrintBulkVehicleService, private spinner: NgxSpinnerService,) { }
  ngOnInit(): void {
    this.selectCampusList();
  }

  
  selectCampusList() {
    this.spinner.show();
    this.bulkservice.getcampusdetail().subscribe(
      {
        next: (res: any) => {
          this.campusdetails = res;
          console.log('CAMPUS', this.campusdetails);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  onSelectedBuilding(event: any) {
    this.CampusId = event.target.value;
    // console.log('this.CampusId', this.CampusId);
    this.spinner.show();
    this.bulkservice.getbuildingdetail(this.CampusId).subscribe(
      {
        next: (res: any) => {
          this.buildingDetails = res;
          console.log('BuildingDetails', this.buildingDetails);

          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    );
  }

  onSelectedTableList(event: any) {
    this.BuildingId = event.target.value;
    console.log('BuildingId', this.BuildingId);
    this.spinner.show();
    this.bulkservice.gettabledetail(this.BuildingId).subscribe(
      {
        next: (res: any) => {
          this.tableDetails = res;
          this.bulkQRData = new MatTableDataSource(this.tableDetails);
          this.bulkQRData.sort = this.sort;
          this.bulkQRData.paginator = this.paginator;
          this.dataAvailable = true;
          console.log('TABLE', this.tableDetails);

          this.spinner.hide();
        },
        error: (error: any) => {
          this.dataAvailable = false;
          this.spinner.hide();
        }
      }
    )
  }

  generateBulkPdf() {
    console.log('this.CampusId', this.CampusId);
    if (!this.CampusId) {
      alert('Please select a Campus');
      return;  // Exit the function if CampusId is missing
    }
  
    if (!this.BuildingId) {
      alert('Please select a Building');
      return;  // Exit the function if BuildingId is missing
    }
    // if (this.CampusId && this.BuildingId) {
      this.spinner.show();
      this.bulkservice.getgeneratepdf(this.BuildingId).subscribe(
        {
          next: (res: Blob) => {
            this.spinner.hide();  // Hide spinner when done
            // Create a download link for the PDF Blob
            const pdfUrl = window.URL.createObjectURL(res);
            console.log('pdfUrl', pdfUrl);
            // Open the PDF in a new tab
            const newTab = window.open();
            if (newTab) {
              // Set the content in the new tab with title and embedded PDF
              newTab.document.write(`
               <html>
                 <head>
                   <title>generateBulkAssetQRCode</title>
                 </head>
                 <body>
                   <embed width="100%" height="100%" src="${pdfUrl}" type="application/pdf" />
                 </body>
               </html>
             `);
            } else {
              console.error('Popup blocked. Please allow popups for this site.');
            }

            setTimeout(() => {
              window.URL.revokeObjectURL(pdfUrl);
            }, 100);  // Revoking after 100ms

          },
          error: (error: any) => {
            this.spinner.hide();
          }
        }
      );

    // }
    //  else {
    //   alert('Please select a Campus and Building');
    // }

  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.bulkQRData.filter = filterValue.trim().toLowerCase();
    console.log('filterValue', filterValue);
  }
}
